/**
 * FreeShipping - 使用 Shopify Ajax API 获取购物车总额
 * 最终版：单位一致（欧元），实时更新，显示正确
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.minimum = parseFloat(this.dataset.minimum); // 包邮门槛（欧元）
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      this.amountSpan = this.querySelector('.free-shipping--text span');

      this.refreshShipping(); // 页面初始运行
      this.initCartWatcher(); // 监听购物车更新
    }

    // 获取购物车最新总额并更新显示
    refreshShipping() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const total = cart.total_price; 
          const remaining = Math.max(this.minimum - total, 0);
          const percentage = total >= this.minimum ? 1 : total / this.minimum;

          // 调试输出（上线后可删除）
          console.log("=== Free Shipping Debug ===");
          console.log("Cart total (euros):", total);
          console.log("Minimum (euros):", this.minimum);
          console.log("Remaining (euros):", remaining);
          console.log("Percentage:", percentage);

          this.style.setProperty('--percentage', percentage);

          if (total < this.minimum) {
            if (this.amountSpan) {
              let format = window.theme?.settings?.money_with_currency_format || "${{amount}}";
              this.amountSpan.innerHTML = formatMoney(remaining, format);
            }
            this.remainingText.style.display = 'block';
            this.fullText.style.display = 'none';
          } else {
            this.remainingText.style.display = 'none';
            this.fullText.style.display = 'block';
          }
        });
    }

    // 监听购物车 Ajax 更新
    initCartWatcher() {
      document.addEventListener('cart:updated', () => this.refreshShipping());
      document.addEventListener('cart:refresh', () => this.refreshShipping());
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
